<td *ngIf="!authenticationService.userIsResident">
    <label class="img-checkbox">
        <input type="checkbox" [ngModel]="data.checked">
        <label><svg-checked></svg-checked></label>
    </label>
</td>
<td class="name" (mousedown)="showDocument(data, $event)" [title]="data.name">
    <span *ngIf="data.type === 'directory'"
          class="fa directory-icon"
          [ngClass]="{'fa-folder': !data.isOpen, 'fa-folder-open': data.isOpen}"
          [title]="data.name">
    </span>
    <i *ngIf="data.type == 'file'" class="fa fa-file-text mtv-primary-color m-r-xs" aria-hidden="true"></i>
<span>{{ data.name }}</span>
</td>
<td *ngIf="!authenticationService.userIsResident && ds.buildings.length > 1">
    <span *ngFor="let building of data.buildings; let last = last;">
        {{ building.name + (!last ? ', ' : '') }}
    </span>
</td>
<td class="td-permissions" *ngIf="!authenticationService.userIsResident">
    <permissions [permissions]="data.documentsPermissions" [parentElementSelector]="'.table-responsive'">
    </permissions>
    <i *ngIf="!data.documentsPermissions?.length" class="icon-close"></i>
</td>
<td class="td-permissions" *ngIf="!authenticationService.userIsResident">
    <labels-list [labelsList]="data.userGroups"></labels-list>
    <i *ngIf="!data.userGroups?.length" class="icon-close"></i>
</td>
<td *ngIf="!authenticationService.userIsResident">
    <span *ngIf="data.isPublic" class="text-uppercase label label-completed">Public</span>
    <i *ngIf="!data.isPublic" class="icon-close"></i>
</td>
<td *ngIf="authenticationService.userIsResident">
    <span>{{ transformSize(data.size) }}</span>
</td>
<td>
    <span>{{ transformDate(data.createdAt) }}</span>
</td>
<td>
    <span>{{ data.createdBy ? data.createdBy.fullName : '' }}</span>
</td>
<td class="td-action-btn" *ngIf="authenticationService.userIsResident">
    <div class="input-group action-button">
        <div class="btn-group dropdown input-group-btn btn-in-table">
            <button data-toggle="dropdown" class="btn btn-white btn-xs same-button-width dropdown-toggle">
                Actions
            </button>
            <button  data-toggle="dropdown" class="btn btn-white btn-xs action__btn">
                <span class="caret"></span>
            </button>
            <ul class="action__dropdown-menu dropdown-menu">
                <li *ngIf="data.type === 'file'" (click)="showDocument(data)">
                    <a>View Document</a>
                </li>
                <li *ngIf="data.type === 'directory'" (click)="showDocument(data)">
                    <a>Open Folder</a>
                </li>
                <li *ngIf="data.type === 'file'">
                    <a [href]="data?.path" [download]="data?.name" target="_blank">
                        Download Document
                    </a>
                </li>
            </ul>
        </div>
    </div>
</td>



// WEBPACK FOOTER //
// /app/src/app/views/documents/document-item/document-item.component.html